import React from 'react'

const PLACEHOLDER = '/metronic/assets/media/avatars/blank.png'

/**
 * Avatar circular con máscara uniforme (object-fit: cover).
 */
export default function UserAvatar({ src, size = 40, alt = '', className = '' }) {
    const url = src || PLACEHOLDER

    return (
        <img
            src={url}
            alt={alt}
            width={size}
            height={size}
            className={className}
            style={{
                width: size,
                height: size,
                borderRadius: '50%',
                objectFit: 'cover',
                display: 'inline-block',
                backgroundColor: '#f5f8fa',
                border: '1px solid #e4e6ef',
                flexShrink: 0,
            }}
            onError={(e) => {
                if (e.currentTarget.src !== PLACEHOLDER) {
                    e.currentTarget.src = PLACEHOLDER
                }
            }}
        />
    )
}
